import React from 'react'
import styled from 'styled-components'

import useReduxSelector from 'hooks/useReduxSelector'

import { media, mediaMax } from 'styles/media'

import FullLogo from '../../../components/icons/BrandLogoPositive'
import Logo from '../../../components/icons/BrandIconPositive'
import SearchBar from '../SearchBar'

import { InverseOption } from '../types'

import { LoggedInLinks, LoggedOutLinks, LinksLoadingSkeleton } from './NavLinks'

const SearchWrapper = styled.div`
  flex-grow: 1;
  max-width: 360px;
  min-width: 270px;
  height: 48px;
  margin-right: 30px;
`

const SmallLogoOnly = styled.div`
  display: flex;
  ${media.xl`
    display: none;
  `}
`

const LargeLogoOnly = styled.div`
  display: flex;
  ${mediaMax.xl`
    display: none;
  `}
`

const LogoWrapper = styled.div<InverseOption>`
  svg {
    height: 36px;
    color: ${({ theme, inverse }) =>
      inverse ? theme['-ds-neutral-100'].value : theme['-ds-core-300'].value};
    margin-right: 30px;
  }
`

const Bar = styled.div<InverseOption>`
  height: 100%;
  width: 100%;
  background-color: transparent;
  padding: 0 30px;

  display: flex;
  align-items: center;
`

const NavLinksWrapper = styled.div<InverseOption>`
  margin-left: auto;
  display: flex;
  align-items: center;

  & > * {
    &:not(:first-child) {
      margin-left: 30px;
    }
  }
`

const Desktop = ({ inverse }: InverseOption) => {
  const isSignedIn = useReduxSelector((state) => state?.auth?.isSignedIn)

  const loading = useReduxSelector((state) => state?.auth?.loading)
  const updating = useReduxSelector((state) => state?.auth?.updating)

  const showLoggedIn = !loading && !updating && isSignedIn === true
  const showLoggedOut = !loading && !updating && isSignedIn === false

  return (
    <Bar inverse={inverse}>
      <a href="/" aria-label="Home page">
        <LogoWrapper inverse={inverse}>
          <LargeLogoOnly>
            <FullLogo />
          </LargeLogoOnly>
          <SmallLogoOnly>
            <Logo />
          </SmallLogoOnly>
        </LogoWrapper>
      </a>
      <SearchWrapper>
        <SearchBar />
      </SearchWrapper>
      <NavLinksWrapper inverse={inverse}>
        {isSignedIn == null && <LinksLoadingSkeleton />}
        {showLoggedIn && <LoggedInLinks inverse={inverse} />}
        {showLoggedOut && <LoggedOutLinks inverse={inverse} />}
      </NavLinksWrapper>
    </Bar>
  )
}

export default Desktop
